<template>
  <div
    class="lg:flex md:flex gap-5 lg:py-10 md:py-20 py-5 lg:px-20 md:px-20 px-5 custflexdirec"
  >
    <div class="lg:w-1/2 md:w-1/2">
      <p
        class="font-semibold fsize35 sm-fsize20 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
      >
        In the News
      </p>

      <p class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13">
        Caregiver Saathi and Rosetta Life joins alliance for The HeArt of Care
        project for raising Awareness and Honouring Carers Worldwide
        <!-- <br />
            To gain inspiration and insights into our collaborative endeavours,
            we encourage you to explore the Gallery page. We believe that the
            images, poetry, and videos will ignite your creativity and provide
            valuable ideas for the images you may consider submitting. Please
            use the Share Your Work page to upload your artwork/image/poetry and
            help us foster greater awareness of Caregiver’s significance in
            society. -->

        <span
          v-b-modal.modal-1
          @click="handleClick('news')"
          class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
          >Know More</span
        >
      </p>
      <div class="flex lg:pt-8 md:pt-8 mob-hidden" v-b-modal.modal-1>
        <base-button
          type="primary"
          class="btntext px-4 py-1"
          @click="handleClick('news')"
          >Know More</base-button
        >
      </div>
    </div>
    <div class="lg:w-1/2 md:w-1/2">
      <img
        src="

https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/IntheNews.png"
        class="w-full custborderradius md:block lg:block object-scale-down h-320px sm-h-180px"
        alt="swiper-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>

<style>
@media (max-width: 640px) {
  .aboutimg {
    top: 416px;
    width: 343px;
    left: 1rem;
  }
  .custflexdirec {
    display: flex;
    flex-direction: column-reverse;
  }
  .sm-h-180px {
    height: 180px !important;
  }
}
.h-320px {
  height: 320px;
}
</style>
